//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Dialog, DialogPositionType} from 'primereact/dialog';
import {MIcon} from '../../Toolkit/Icons';

//endregion

/** */
type Props = {
    title: string;
    content: string | ReactNode;
    icon?: MIcon;
    footer?: ReactNode;
    position?: DialogPositionType;
    visible: boolean;
    canClose?: boolean;
    centreContent?: boolean;
    closeOnEscape?: boolean;
    onHide?: () => void;
    style?: object;
}

/** */
class MDialog extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.bindMethods();
    }

    /** */
    private bindMethods(): void {

        this.getContentTemplate = this.getContentTemplate.bind(this);
        this.dialog_onHide = this.dialog_onHide.bind(this);

    }

    /** */
    private getContentTemplate(): ReactNode {

        const hasIcon = this.props.icon !== undefined;
        const isMessageString = typeof this.props.content === 'string';

        return (
            <div className="flex align-items-center">
                {hasIcon && <span className={`pi ${this.props.icon!.name} ${this.props.icon!.color} text-4xl mr-3`}/>}
                {isMessageString ? <span>{this.props.content}</span> : this.props.content}
            </div>
        );

    }

    /** */
    private dialog_onHide(): void {
        this.props.onHide?.();
    }

    /** */
    public render(): ReactElement {

        const canClose = this.props.canClose ?? true;
        const closeOnEscape = this.props.closeOnEscape ?? true;
        const contentClass = this.props.centreContent === true ? "flex align-items-center justify-content-center" : "flex align-items-center";

        return (
            <Dialog header={this.props.title}
                    footer={this.props.footer}
                    visible={this.props.visible}
                    position={this.props.position}
                    style={this.props.style === undefined ? {width: '35vw'} : this.props.style}
                    modal={true}
                    closable={canClose}
                    closeOnEscape={closeOnEscape}
                    draggable={false}
                    resizable={false}
                    maximizable={false}
                    onHide={this.dialog_onHide}
                    dismissableMask={true}
            >
                <div className={contentClass}>
                    {this.getContentTemplate()}
                </div>
            </Dialog>
        );

    }

}

export default MDialog;
